import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { MAX_LINK_NUMBER } from '../../../../_events/_manage-event/_meetings-list/_meeting-form/_links/links.viewmodel';
import { OpenFormInPopOverBtn } from '../../../../_events/_manage-event/_meetings-list/_meeting-form/_links/links.container';
import { MeetingTemplateLinksVM } from './meeting-template-links.viewmodel';
import { MeetingTemplateLink } from '../../../../../api/blueprints/meeting.template.types';
import { LinkItem } from '../../../../_events/_manage-event/_meetings-list/_meeting-form/_links/link-item/link-item';


type MeetingTemplateLinksProps = {
    vm: MeetingTemplateLinksVM;
};

export const MeetingTemplateLinks = observer((props: MeetingTemplateLinksProps): JSX.Element => {
    const { vm } = props;

    return (
        <div className='event_form__items-section'>
            <div className='event_form__items-section__title'>
                <FormattedMessage id='oe.meeting.links' description='Title text' defaultMessage='Links' />
            </div>
            <div className='event_form__items-section__selected-items'>
                {
                    vm.getLinks().map((link, index) => {
                        return <LinkItem
                            key={index}
                            onDelete={vm.removeLinkByIndex.bind(vm, index)}
                            isMeetingLink
                            {...link}
                        />;
                    })
                }
            </div>
            <div className='add-link-btn-wrapper'>
                {(vm.getLinks().length < MAX_LINK_NUMBER) &&
                    <OpenFormInPopOverBtn
                        onApply={(link: MeetingTemplateLink) => vm.onAddLink(link)}
                    />
                }
            </div>
        </div>
    );
});
